import React from 'react';

const About = () => {
    return (
        <div>
            <h1>We are secret.</h1>
            <p>But you can know about us.</p>
        </div>
    );
};

export default About;